import { render, staticRenderFns } from "./UpdateTeam.vue?vue&type=template&id=8b8fab9a&"
import script from "./UpdateTeam.vue?vue&type=script&lang=js&"
export * from "./UpdateTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports